export default "__VITE_ASSET__88b12467__"